import { Popover, PopoverInteractionKind, Position } from "@blueprintjs/core"
import TextEditorTools from "./TextEditorTools"
import { useRef, useState } from "react"

/* Protopia Ecosystem component */
export interface ITextEditorProps {
   children: JSX.Element
   onChange: (value: string) => void
}
const TextEditor = (props: ITextEditorProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const onChange = () => {
        const content = (ref.current as any)?.querySelector(".content-editable")
        if( content?.innerHTML ) {
            console.log( content.innerHTML )
            props.onChange( content.innerHTML ) 
        }
    }
    return <Popover
        position={Position.TOP_LEFT}
        hasBackdrop={false}
        // isOpen={isOpen}
        onClose={ () => setIsOpen(false)}  
        content={<TextEditorTools onChange={onChange} />}
        interactionKind={PopoverInteractionKind.CLICK}
        portalClassName="z-index-80"
        popoverClassName="w-100"
        className="w-100"
        modifiers={{ 
            arrow: { enabled: false },
            flip: { enabled: true },
            preventOverflow: { enabled: false },
            offset: { enabled: true, options: {
                offset: [ 3, 4],
            } }, 
        }}
        autoFocus={false}
    >
        <div ref={ref} onClick={() => setIsOpen(true) }  data-select-type="ignore">
            {props.children}
        </div>
    </Popover>
}
export default TextEditor